import Image from 'next/image';
import { useEffect, useState } from 'react';

import CommentPopup from 'components/CommentPopup';
import Footer from 'components/Footer';
import Head from 'components/Head';
import MaxWidthContainer from 'components/MaxWidthContainer';
import Menubar from 'components/Menubar';

import { onAuthStateChanged } from 'firebase/auth';
import { fetchAppLaunch } from 'functions/appLaunch';
import { httpCall } from 'functions/httpAction';
import { usePathname } from 'next/navigation';
import api from 'utils/api';
import { firebaseAuth } from 'utils/firebaseConfig';
import redirectToLogin from 'utils/redirectToLogin';

import { useUserAuth } from 'contexts/UserAuth';

export default function Nominate() {
  //from AppLaunch API
  const [arrNotificationState, setArrNotificationState] = useState(null);
  const [arrStoresState, setArrStoresState] = useState(null);
  const [arrProductOriginsState, setArrProductOriginsState] = useState(null);
  const [arrCategoryState, setArrCategoryState] = useState([]);
  const [arrSearchSkinProblemState, setArrSearchSkinProblemState] = useState(
    []
  );
  const [arrIngredientSafetiesState, setArrIngredientSafetiesState] = useState(
    []
  );
  const [arrFactorTypesState, setArrFactorTypesState] = useState([]);
  const [defaultSecondCategoryState, setDefaultSecondCategoryState] =
    useState(null);

  //from Firebase
  const [isUserLoggedIn, setIsUserLoggeedIn] = useState(false);
  const [firUser, setFirUser] = useState(null);

  //core properties
  const [isCommentModalShow, setIsCommentModalShow] = useState(false);
  const pathname = usePathname();
  const [isLoading, setIsLoading] = useState(false);

  //form fields
  const [searchBrandIdState, setSearchBrandIdState] = useState('');
  const [isSelectedDynamicGroup, setIsSelectedDynamicGroup] = useState(false);
  const [brandDynamicState, setBrandDynamicState] = useState('');
  const [nameState, setNameState] = useState('');
  const [nameENState, setNameENState] = useState('');
  const [linkState, setLinkState] = useState('');
  const [searchCategoryIdState, setSearchCategoryIdState] = useState('');
  const [isSelectedOwner, setIsSelectedOwner] = useState(false);
  const [ownerContactState, setOwnerContactState] = useState('');

  //form filled status
  const [isBrandNotFilled, setIsBrandNotFilled] = useState(false);
  const [isNameNotFilled, setIsNameNotFilled] = useState(false);
  const [isCategoryNotFilled, setIsCategoryNotFilled] = useState(false);
  const [isOwnerContactNotFilled, setIsOwnerContactNotFilled] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  //brand selection
  const [searchBrandInputFocusState, setSearchBrandInputFocusState] =
    useState(false);
  const [arrBrandsState, setArrBrandsState] = useState([]);
  const [searchBrandsLoadingState, setSearchBrandsLoadingState] =
    useState(false);
  const [searchBrandKeywordState, setSearchBrandKeywordState] = useState('');
  const [blockSearchBrandState, setBlockSearchBrandState] = useState('');
  const [
    arrSearchCategoryMobileCollapseState,
    setArrSearchCategoryMobileCollapseState,
  ] = useState([]);

  //category selection
  const [searchCategoryInputFocusState, setSearchCategoryInputFocusState] =
    useState(false);
  const [
    searchCategoryInputFocusMobileState,
    setSearchCategoryInputFocusMobileState,
  ] = useState(false);
  const [searchCategoryKeywordState, setSearchCategoryKeywordState] =
    useState('');
  const [blockSearchCategoryState, setBlockSearchCategoryState] = useState('');
  const [blockSearchCategoryMobileState, setBlockSearchCategoryMobileState] =
    useState('');

  const { getAuthorizationHeader } = useUserAuth();

  function appLaunch() {
    fetchAppLaunch().then(([success, error, data]) => {
      console.log(data);

      if (data.notifications) {
        setArrNotificationState(data.notifications);
      }

      if (data.stores) {
        setArrStoresState(data.stores);
      }

      if (data.product_origins) {
        setArrProductOriginsState(data.product_origins);
      }

      if (data.category_tree) {
        setArrCategoryState(data.category_tree);
      }

      if (data.search_skin_problem_keywords) {
        setArrSearchSkinProblemState(data.search_skin_problem_keywords);
      }

      if (data.ingredient_safeties) {
        setArrIngredientSafetiesState(data.ingredient_safeties);
      }

      if (data.factor_types) {
        setArrFactorTypesState(data.factor_types);
      }

      if (data.default_second_category) {
        setDefaultSecondCategoryState(data.default_second_category);
      }

      checkSignIn();
    });
  }

  async function checkSignIn() {
    onAuthStateChanged(firebaseAuth, (user) => {
      if (user) {
        setIsUserLoggeedIn(true);
        setFirUser(user);
      } else {
        setIsUserLoggeedIn(false);
        setFirUser(null);

        // redirectToLogin()
        redirectToLogin(pathname);
      }
    });
  }

  const resetWarningState = () => {
    setIsBrandNotFilled(false);
    setIsNameNotFilled(false);
  };

  function pressSearchBrandInputFocus(focused) {
    setSearchBrandInputFocusState(focused);

    if (focused == true) {
      setSearchBrandKeywordState('');
      setSearchBrandIdState('');

      if (searchBrandKeywordState != '' && searchBrandIdState != '') {
        setArrSearchProductsState([]);
        fetchSearchBrands();
      }
    }
  }

  function pressSearchCategoryInputFocus(focused) {
    setSearchCategoryInputFocusState(focused);

    if (focused == true) {
      setSearchCategoryKeywordState('');
      setSearchCategoryIdState('');

      if (searchCategoryKeywordState != '' && searchCategoryIdState != '') {
        // setArrSearchProductsState([]);
        // fetchSearchBrands()
      }
    }
  }

  function pressSearchCategoryInputFocusMobile(focused) {
    setSearchCategoryInputFocusMobileState(focused);

    if (focused == true) {
      setSearchCategoryKeywordState('');
      setSearchCategoryIdState('');

      if (searchCategoryKeywordState != '' && searchCategoryIdState != '') {
        // setArrSearchProductsState([]);
        // fetchSearchBrands()
      }
    }
  }

  async function fetchSearchBrands() {
    setSearchBrandsLoadingState(true);

    try {
      const [success, error, statusCode, data] = await httpCall(
        'get',
        process.env.NEXT_PUBLIC_API_HOST +
          '/api/v2/search?keyword=' +
          searchBrandKeywordState +
          '&init_product_count=4&limit=8',
        null,
        null
      );

      setSearchBrandsLoadingState(false);

      if (success == true) {
        if (data.products != null) {
          var arrBrandTmp = [];

          console.log(data);

          data.brands.forEach((element) => {
            arrBrandTmp.push(element);
          });

          setArrBrandsState(arrBrandTmp);
        }
      } else {
        console.log('api error', error);
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  function loadBlockSearchBrand() {
    var blockSearchBrandTmp = [];

    if (searchBrandsLoadingState == true) {
      blockSearchBrandTmp.push(
        <div className="flex h-full w-full items-center justify-center">
          <div className="space-y-3">
            <img
              className="m-[auto] h-[160px] w-[160px]"
              src="/images/search-placeholder.gif"
            ></img>
          </div>
        </div>
      );
    } else {
      arrBrandsState.forEach(function (element, index) {
        var imageURL = '';

        if (element.image != null) {
          imageURL = element.image.url;
        } else {
          imageURL = 'images/placeholders/brand.png';
        }

        blockSearchBrandTmp.push(
          <div
            className="flex h-[40px] cursor-pointer space-x-[16px]"
            onClick={() => {
              console.log({ element });
              setSearchBrandKeywordState(element.name);
              setSearchBrandIdState(element.id);

              setSearchBrandInputFocusState(false);
            }}
          >
            <img src={imageURL} className="h-[40px] w-[40px]"></img>
            <div className="h-full w-full">
              <div className="text-sm font-medium text-sorra-gray-900">
                {element.name}
              </div>
              <div className="pt-0.5 text-sm font-medium text-sorra-gray-800">
                {element.name}
              </div>
            </div>
          </div>
        );
      });
    }

    setBlockSearchBrandState(blockSearchBrandTmp);
  }

  function loadBlockSearchCategory() {
    var arrCategoryStateFiltered = [];

    if (searchCategoryKeywordState == '') {
      arrCategoryStateFiltered = arrCategoryState;
    } else {
      arrCategoryState.forEach((element) => {
        var categoryTmp = JSON.parse(JSON.stringify(element));
        var arrSubCategoryStateFiltered = [];

        element.second_categories.forEach((subelement) => {
          if (subelement.name.includes(searchCategoryKeywordState)) {
            arrSubCategoryStateFiltered.push(subelement);
          }
        });

        categoryTmp.second_categories = arrSubCategoryStateFiltered;

        arrCategoryStateFiltered.push(categoryTmp);
      });
    }

    var blockSearchCategoryTmp = [];
    var blockSearchCategoryMobileTmp = [];

    arrCategoryStateFiltered.forEach(function (element, index) {
      var blockSearchSubcategoryTmp = [];

      element.second_categories.forEach((subelement) => {
        blockSearchSubcategoryTmp.push(
          <div
            className="flex cursor-pointer gap-x-0.5 hover:ml-1"
            onClick={() => {
              setSearchCategoryKeywordState(subelement.name);
              setSearchCategoryIdState(subelement.id);

              setSearchCategoryInputFocusState(false);
              setSearchCategoryInputFocusMobileState(false);
            }}
          >
            <img
              src="/svgs/index-partnership-arrow.svg"
              className="mb-[auto] mt-[2px]"
            ></img>
            <div className="text-sm font-medium text-sorra-gray-900">
              {subelement.name}
            </div>
          </div>
        );
      });

      blockSearchCategoryTmp.push(
        <div className="space-y-2">
          <div className="text-sorra-gray-900">{element.name}</div>
          {blockSearchSubcategoryTmp}
        </div>
      );

      blockSearchCategoryMobileTmp.push(
        <div className="border-b-2 border-gray-100">
          <div
            className="flex cursor-pointer gap-x-4 p-4 text-sm font-medium text-sorra-gray-800"
            onClick={() => pressSearchCategoryMobileExpands(index)}
          >
            <div className="grow">{element.name}</div>
            <img
              src={
                arrSearchCategoryMobileCollapseState.includes(index)
                  ? '/svgs/chevron-down.svg'
                  : '/svgs/chevron-up.svg'
              }
            ></img>
          </div>
          <div
            className={
              'grid grid-cols-2 gap-y-4 px-4 pb-4' +
              (blockSearchSubcategoryTmp.length == 0 ||
              arrSearchCategoryMobileCollapseState.includes(index)
                ? ' hidden'
                : '')
            }
          >
            {blockSearchSubcategoryTmp}
          </div>
        </div>
      );
    });

    setBlockSearchCategoryState(
      <div className="flex grid max-h-full w-full grid-cols-5 gap-x-4 gap-y-8 overflow-y-scroll px-2 pb-6">
        {blockSearchCategoryTmp}
      </div>
    );

    setBlockSearchCategoryMobileState(
      <div className="w-[calc(100% + 32px)] mx-[-16px] mt-[-32px] max-h-full overflow-y-scroll">
        {blockSearchCategoryMobileTmp}
      </div>
    );
  }

  function pressSearchCategoryMobileExpands(index) {
    var arrSearchCategoryMobileCollapseTmp =
      arrSearchCategoryMobileCollapseState.concat();

    if (arrSearchCategoryMobileCollapseTmp.includes(index)) {
      var index = arrSearchCategoryMobileCollapseTmp.indexOf(index);
      if (index > -1) {
        arrSearchCategoryMobileCollapseTmp.splice(index, 1);
      }
    } else {
      arrSearchCategoryMobileCollapseTmp.push(index);
    }

    setArrSearchCategoryMobileCollapseState(arrSearchCategoryMobileCollapseTmp);
  }

  function pressSubmit() {
    var isFormOK = true;

    if (isSelectedDynamicGroup == false) {
      if (searchBrandIdState != null && searchBrandIdState != '') {
        setIsBrandNotFilled(false);
      } else {
        setIsBrandNotFilled(true);

        isFormOK = false;
      }
    } else {
      if (brandDynamicState != null && brandDynamicState != '') {
        setIsBrandNotFilled(false);
      } else {
        setIsBrandNotFilled(true);

        isFormOK = false;
      }
    }

    if (nameState != null && nameState != '') {
      setIsNameNotFilled(false);
    } else {
      setIsNameNotFilled(true);

      isFormOK = false;
    }

    if (searchCategoryIdState != null && searchCategoryIdState != '') {
      setIsCategoryNotFilled(false);
    } else {
      setIsCategoryNotFilled(true);

      isFormOK = false;
    }

    if (isFormOK == true) {
      submitNormination();
    }
  }

  async function submitNormination() {
    setIsLoading(true);
    setErrorMsg('');

    const auth = firebaseAuth;
    const user = auth.currentUser;

    if (user == null) {
      window.location = '/';
    } else {
      const headers = await getAuthorizationHeader();
      const passObject = JSON.stringify({
        brand: isSelectedDynamicGroup ? null : searchBrandIdState,
        manual_brand: !isSelectedDynamicGroup ? null : brandDynamicState,
        name: nameState,
        en_name: nameENState,
        second_category: searchCategoryIdState,
        suggest_url: linkState,
        is_responsible_person: isSelectedOwner,
        responsible_person_contact: ownerContactState,
      });

      try {
        const { data } = await api.request({
          method: 'POST',
          url: '/api/v2/products/nominate',
          data: passObject,
          headers,
        });

        if (data) {
          window.location = '/nominate/success?productID=' + data.id;
        }
      } catch (error) {
        console.log('api error:', error);
        setErrorMsg('發生錯誤，請稍後再試。');
      }
      setIsLoading(false);
    }
  }

  useEffect(() => {
    appLaunch();
  }, []);

  useEffect(() => {
    fetchSearchBrands();
  }, [searchBrandKeywordState]);

  useEffect(() => {
    loadBlockSearchBrand();
  }, [arrBrandsState, searchBrandsLoadingState]);

  useEffect(() => {
    loadBlockSearchCategory();
  }, [
    arrCategoryState,
    searchCategoryKeywordState,
    arrSearchCategoryMobileCollapseState,
  ]);

  return (
    <div>
      <Head />

      <main>
        <div className="hidden lg:block">
          <Menubar
            props={{
              homeExtend: false,
              notifications: arrNotificationState,
              sourceUI: 'Rewards',
            }}
          />
        </div>

        <div className="fixed top-0 z-30 w-full bg-white lg:hidden">
          <div className="left-0 top-0 h-[96px] w-full px-[16px] py-[24px]">
            <button
              className="border-text-gray-100 absolute left-[16px] mb-2 mr-2 h-[48px] w-[48px] rounded-lg border p-[14px] text-center text-sm font-medium text-gray-100 focus:outline-none focus:ring-4 focus:ring-blue-300"
              onClick={() => {
                window.location = '/';
              }}
            >
              <img
                src="/svgs/modal-back.svg"
                className="h-[20px] w-[20px]"
              ></img>
            </button>

            <div className="flex h-[48px] items-center justify-center text-center text-lg font-medium text-sorra-gray-800">
              產品提名
            </div>
          </div>
        </div>

        <div
          className={
            'globals-centerContentsMargin relative' +
            (arrNotificationState?.length > 0 ? ' withNoti' : '')
          }
        >
          <MaxWidthContainer className="relative gap-x-[32px] px-4">
            <div
              className="hidden w-[100%] overflow-y-scroll pt-[32px] lg:block"
              onClick={() => (window.location = `/`)}
            >
              首頁 &gt;{' '}
              <span
                className="cursor-pointer"
                onClick={() => (window.location = `/suggestions`)}
              >
                產品提名
              </span>
            </div>
            <div className="hidden py-[16px] text-3xl font-bold text-sorra-gray-900 lg:block lg:py-[32px] lg:text-4xl">
              產品提名
            </div>
          </MaxWidthContainer>

          <MaxWidthContainer className="relative gap-x-[32px] px-4">
            <div className="w-full">
              <div className="ml-auto mr-auto h-[1000px] w-full max-w-[445px]">
                <div className="mt-[24px] font-[500]" id="rank_comment">
                  <div className="flex items-center space-x-2">
                    <div
                      className={
                        'text-base font-medium' +
                        (isSelectedDynamicGroup == true
                          ? ' text-sorra-gray-500'
                          : ' text-sorra-gray-900')
                      }
                    >
                      品牌
                    </div>
                    {isBrandNotFilled ? (
                      <div className="flex items-center space-x-1 text-sm text-sorra-orange-warning">
                        <Image
                          src="/svgs/warning.svg"
                          alt=""
                          className="mt-1"
                          width={16}
                          height={16}
                        />
                        <span>必填欄位</span>
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="relative mb-[24px] mt-[8px] h-[48px] w-full">
                  <input
                    type="text"
                    id=""
                    className={`bg-gray-0 border ${isBrandNotFilled ? 'border-sorra-orange-warning' : 'border-gray-300'} block h-full w-full rounded-lg p-2.5 px-[18px] font-medium text-sorra-gray-900 focus:border-gray-800 focus:ring-0 focus:ring-offset-0`}
                    placeholder="品牌名稱"
                    autoComplete="false"
                    autoCorrect="false"
                    disabled={isSelectedDynamicGroup == true ? 'true' : ''}
                    value={searchBrandKeywordState}
                    onFocus={() => {
                      if (isSelectedDynamicGroup == true) {
                        pressSearchBrandInputFocus(false);
                      } else {
                        pressSearchBrandInputFocus(true);
                      }
                    }}
                    onBlur={() => {
                      window.setTimeout(function () {
                        if (isSelectedDynamicGroup == true) {
                          pressSearchBrandInputFocus(false);
                        } else {
                          if (searchBrandKeywordState == '') {
                            pressSearchBrandInputFocus(false);
                          }
                        }
                      }, 100);
                    }}
                    onChange={(event) => {
                      resetWarningState();
                      setSearchBrandKeywordState(event.target.value);
                      setSearchBrandIdState('');
                      // setIsPostError(false)
                    }}
                  />
                  <button
                    className="absolute inset-y-0 right-0 flex items-center pr-6 text-sorra-pink"
                    onClick={() => {
                      setSearchBrandKeywordState('');
                      setSearchBrandIdState('');
                      // setIsPostError(false)
                    }}
                  >
                    {searchBrandKeywordState != '' ? (
                      <Image
                        src="/svgs/clear.svg"
                        alt="clear"
                        width={14}
                        height={14}
                      />
                    ) : (
                      ''
                    )}
                  </button>
                </div>

                <div
                  className={
                    'space-y-[16px]' +
                    (searchBrandInputFocusState == true ? ' block' : ' hidden')
                  }
                >
                  {blockSearchBrandState}
                </div>

                <div className="mt-[18px] flex items-center space-x-2">
                  <input
                    className={`h-[20px] w-[20px] cursor-pointer rounded-[4px] text-sorra-pink focus:ring-0`}
                    type="checkbox"
                    onChange={(e) => {
                      console.log(e.target.checked);
                      setIsSelectedDynamicGroup(e.target.checked);

                      if (e.target.checked == true) {
                        setSearchBrandKeywordState('');
                        setSearchBrandIdState('');
                        pressSearchBrandInputFocus(false);
                      }
                    }}
                  />
                  <div className="text-[#111928]">
                    未能找到品牌，我想手動填寫。
                  </div>
                </div>

                {isSelectedDynamicGroup == false ? (
                  <></>
                ) : (
                  <>
                    <div className="mt-[24px] font-[500]" id="rank_comment">
                      <div className="flex items-center space-x-2">
                        <div className="text-base font-medium text-sorra-gray-900">
                          品牌（手動填寫）
                        </div>
                        {isBrandNotFilled ? (
                          <div className="flex items-center space-x-1 text-sm text-sorra-orange-warning">
                            <Image
                              src="/svgs/warning.svg"
                              alt=""
                              className="mt-1"
                              width={16}
                              height={16}
                            />
                            <span>必填欄位</span>
                          </div>
                        ) : null}
                      </div>
                    </div>

                    <div className="relative mb-[24px] mt-[8px] h-[48px] w-full">
                      <input
                        type="text"
                        id=""
                        className={`bg-gray-0 border ${isBrandNotFilled ? 'border-sorra-orange-warning' : 'border-gray-300'} block h-full w-full rounded-lg p-2.5 px-[18px] font-medium text-sorra-gray-900 focus:border-gray-800 focus:ring-0 focus:ring-offset-0`}
                        placeholder="品牌名稱（手動填寫）"
                        value={brandDynamicState}
                        onChange={(e) => {
                          setBrandDynamicState(e.target.value);
                        }}
                      />
                    </div>
                  </>
                )}

                <div className="mt-[24px] font-[500]" id="rank_comment">
                  <div className="flex items-center space-x-2">
                    <div className="text-base font-medium text-sorra-gray-900">
                      產品名稱（中文）
                    </div>
                    {isNameNotFilled ? (
                      <div className="flex items-center space-x-1 text-sm text-sorra-orange-warning">
                        <Image
                          src="/svgs/warning.svg"
                          alt=""
                          className="mt-1"
                          width={16}
                          height={16}
                        />
                        <span>必填欄位</span>
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="relative mb-[24px] mt-[8px] h-[48px] w-full">
                  <input
                    type="text"
                    id=""
                    className={`bg-gray-0 border ${isNameNotFilled ? 'border-sorra-orange-warning' : 'border-gray-300'} block h-full w-full rounded-lg p-2.5 px-[18px] font-medium text-sorra-gray-900 focus:border-gray-800 focus:ring-0 focus:ring-offset-0`}
                    placeholder="產品名稱"
                    value={nameState}
                    onChange={(e) => {
                      setNameState(e.target.value);
                    }}
                  />
                </div>

                <div className="mt-[24px] font-[500]" id="rank_comment">
                  <div className="flex items-center space-x-2">
                    <div className="text-base font-medium text-sorra-gray-900">
                      產品名稱（英文）
                    </div>
                    <div className="grow" />
                    <div className="flex items-center space-x-1 text-sm text-sorra-gray-800">
                      <span>選填</span>
                    </div>
                  </div>
                </div>

                <div className="relative mb-[24px] mt-[8px] h-[48px] w-full">
                  <input
                    type="text"
                    id=""
                    className={`bg-gray-0 block h-full w-full rounded-lg border border-gray-300 p-2.5 px-[18px] font-medium text-sorra-gray-900 focus:border-gray-800 focus:ring-0 focus:ring-offset-0`}
                    placeholder="產品名稱"
                    value={nameENState}
                    onChange={(e) => {
                      setNameENState(e.target.value);
                    }}
                  />
                </div>

                <div className="mt-[24px] font-[500]" id="rank_comment">
                  <div className="flex items-center space-x-2">
                    <div className="text-base font-medium text-sorra-gray-900">
                      產品連結
                    </div>
                    <div className="grow" />
                    <div className="flex items-center space-x-1 text-sm text-sorra-gray-800">
                      <span>選填</span>
                    </div>
                  </div>
                </div>

                <div className="relative mb-[24px] mt-[8px] h-[48px] w-full">
                  <input
                    type="text"
                    id=""
                    className={`bg-gray-0 block h-full w-full rounded-lg border border-gray-300 p-2.5 px-[18px] font-medium text-sorra-gray-900 focus:border-gray-800 focus:ring-0 focus:ring-offset-0`}
                    placeholder="https://www.abc.com.hk/xxx"
                    value={linkState}
                    onChange={(e) => {
                      setLinkState(e.target.value);
                    }}
                  />
                </div>

                <div className="mt-[24px] font-[500]" id="rank_comment">
                  <div className="flex items-center space-x-2">
                    <div className="text-base font-medium text-sorra-gray-900">
                      產品類型
                    </div>
                    <div className="grow" />
                    <div className="flex items-center space-x-1 text-sm text-sorra-gray-800">
                      若無法分類，則選擇
                      <span
                        className="cursor-pointer text-sorra-pink"
                        onClick={() => {
                          setSearchCategoryInputFocusState(false);
                          setSearchCategoryIdState(defaultSecondCategoryState);
                          setSearchCategoryKeywordState('暫無分類');
                        }}
                      >
                        「暫無分類」
                      </span>
                    </div>
                  </div>
                </div>

                <div className="relative mb-[24px] mt-[8px] h-[48px] w-full">
                  <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-[16px]">
                    <img src="/svgs/search.svg"></img>
                  </div>
                  <input
                    type="text"
                    id=""
                    className={`bg-gray-0 border ${isCategoryNotFilled ? 'border-sorra-orange-warning' : 'border-gray-300'} block h-full w-full rounded-lg p-2.5 pl-[56px] font-medium text-sorra-gray-900 focus:border-gray-800 focus:ring-0 focus:ring-offset-0`}
                    placeholder="產品類型"
                    autoComplete="false"
                    autoCorrect="false"
                    value={searchCategoryKeywordState}
                    onFocus={() => {
                      pressSearchCategoryInputFocus(true);
                      pressSearchCategoryInputFocusMobile(true);
                    }}
                    onBlur={() => {
                      window.setTimeout(function () {
                        if (searchCategoryKeywordState == '') {
                          pressSearchCategoryInputFocus(false);
                        }
                      }, 100);
                    }}
                    onChange={(event) => {
                      resetWarningState();
                      setSearchCategoryKeywordState(event.target.value);
                      setSearchCategoryIdState('');
                      // setIsPostError(false)
                    }}
                  />
                  <button
                    className="absolute inset-y-0 right-0 flex items-center pr-6 text-sorra-pink"
                    onClick={() => {
                      setSearchCategoryKeywordState('');
                      setSearchCategoryIdState('');
                      // setIsPostError(false)
                    }}
                  >
                    {searchBrandKeywordState != '' ? (
                      <Image
                        src="/svgs/clear.svg"
                        alt="clear"
                        width={14}
                        height={14}
                      />
                    ) : (
                      ''
                    )}
                  </button>
                </div>

                <div
                  className={
                    'relative top-[00px] z-[50] ml-[-300px] hidden h-[345px] w-[1024px] rounded-lg border border-gray-300 bg-white px-4 pt-6' +
                    (searchCategoryInputFocusState == true
                      ? ' lg:block'
                      : ' lg:hidden')
                  }
                >
                  <div className="absolute top-[-10px] ml-[320px] h-[20px] w-[20px] rotate-[45deg] border-l border-t border-gray-300 bg-white"></div>

                  <div className="h-full w-full space-y-4">
                    {blockSearchCategoryState}
                  </div>
                </div>

                <div
                  className={
                    (searchCategoryInputFocusMobileState == true
                      ? 'block'
                      : 'hidden') +
                    ' fixed left-[0px] top-[0px] z-40 h-full w-full overflow-y-auto bg-[#ffffff] pt-24 lg:hidden'
                  }
                >
                  <div className="fixed top-0 z-50 w-full bg-white lg:hidden">
                    <div className="left-0 top-0 h-[96px] w-full px-[16px] py-[24px]">
                      <button
                        className="border-text-gray-100 absolute left-[16px] mb-2 mr-2 h-[48px] w-[48px] rounded-lg border p-[14px] text-center text-sm font-medium text-gray-100 focus:outline-none focus:ring-4 focus:ring-blue-300"
                        onClick={() => {
                          setSearchCategoryInputFocusMobileState(false);
                        }}
                      >
                        <img
                          src="/svgs/modal-back.svg"
                          className="h-[20px] w-[20px]"
                        ></img>
                      </button>

                      <div className="flex h-[48px] items-center justify-center text-center text-lg font-medium text-sorra-gray-800">
                        產品類型
                      </div>
                    </div>
                  </div>

                  <div className="p-4">{blockSearchCategoryMobileState}</div>
                </div>

                <div className="mt-[18px] flex items-center space-x-2">
                  <input
                    className={`h-[20px] w-[20px] cursor-pointer rounded-[4px] text-sorra-pink focus:ring-0`}
                    type="checkbox"
                    onChange={(e) => {
                      console.log(e.target.checked);
                      setIsSelectedOwner(e.target.checked);

                      if (e.target.checked == true) {
                        // setSearchBrandKeywordState('')
                        // setSearchBrandIdState('');
                      }
                    }}
                  />
                  <div className="text-[#111928]">我是品牌方代表／負責人。</div>
                </div>

                {isSelectedOwner && (
                  <div className="mb-[24px] mt-[16px] rounded-lg border border-sorra-pink bg-[#fff6f7] p-4 text-sm leading-relaxed text-[#111928]">
                    如需批量提名產品，可以到{' '}
                    <a
                      href="/business-inquiry"
                      className="font-semibold text-sorra-pink underline"
                    >
                      商業或媒體聯絡
                    </a>{' '}
                    免費提交需求，會有專人聯絡協助。
                  </div>
                )}
                {errorMsg && (
                  <div className="mt-[16px] hidden items-center gap-2 text-sm font-[500] text-sorra-orange-warning lg:flex">
                    <Image
                      src="/svgs/warning.svg"
                      className="mt-1"
                      width={16}
                      height={16}
                      alt="error"
                    />
                    <span>{errorMsg}</span>
                  </div>
                )}
                <div className="mt-[34px] hidden items-center justify-center text-[16px] font-[500] lg:flex">
                  <button
                    className="mr-[16px] h-[48px] grow rounded-[8px] border-[1px]"
                    onClick={() => (window.location = `/`)}
                  >
                    返回
                  </button>
                  <button
                    className={`${isLoading ? 'bg-sorra-pink-light' : 'bg-sorra-pink'} h-[48px] grow rounded-[8px] text-[#fff]`}
                    onClick={() => pressSubmit()}
                  >
                    {isLoading ? '載入中' : '下一步'}
                  </button>
                </div>
              </div>
            </div>
          </MaxWidthContainer>
        </div>

        <div className="fixed bottom-0 z-30 w-full bg-white lg:hidden">
          <MaxWidthContainer className="relative gap-x-[32px] px-4 pb-[32px]">
            {errorMsg && (
              <div className="mt-[16px] flex flex-row items-center gap-2 text-sm font-[500] text-sorra-orange-warning">
                <Image
                  src="/svgs/warning.svg"
                  className="mt-1"
                  width={16}
                  height={16}
                  alt="error"
                />
                <span>{errorMsg}</span>
              </div>
            )}
            <div className="mt-[34px] flex items-center justify-center text-[16px] font-[500]">
              <button
                className="mr-[16px] h-[48px] grow rounded-[8px] border-[1px]"
                onClick={() => (window.location = `/`)}
              >
                返回
              </button>
              <button
                className={`${isLoading ? 'bg-sorra-pink-light' : 'bg-sorra-pink'} h-[48px] grow rounded-[8px] text-[#fff]`}
                onClick={() => pressSubmit()}
              >
                {isLoading ? '載入中' : '下一步'}
              </button>
            </div>
          </MaxWidthContainer>
        </div>

        <div className="hidden lg:block">
          <CommentPopup
            externalPopupShown={isCommentModalShow}
            externalProductID={null}
            externalProductBrandName={null}
            externalProductName={null}
            setExternalPopupShown={setIsCommentModalShow}
          />

          <Footer />
        </div>
      </main>
    </div>
  );
}
